/** Join conditional class names. Deliberately not `clsx` — one helper, no dep. */
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ')
}
